import React, { ReactElement, ReactNode } from 'react';
import { LocalStoreProviderContext } from './LocalStoreProvider.constants';

interface IProps<T> {
  children: ReactNode;
  localStore: T;
}

export const LocalStoreProvider = <T extends Record<string, any>>(props: IProps<T>): ReactElement => {
  return (
    <LocalStoreProviderContext.Provider value={props.localStore as any}>
      {props.children}
    </LocalStoreProviderContext.Provider>
  );
};

LocalStoreProvider.displayName = 'LocalStoreProvider';
